(() => {
  'use strict';
  if (window.LANEWILD_THEME_BOUND) return;
  window.LANEWILD_THEME_BOUND = true;
  const dialogTriggers = new WeakMap();
  function openLocalization(trigger) {
    const dialog = document.querySelector('.localization-dialog');
    if (!dialog || dialog.open) return;
    dialogTriggers.set(dialog, trigger);
    const summary = document.querySelector('[data-localization-disclosure] > summary');
    summary?.setAttribute('aria-expanded', 'true');
    dialog.showModal();
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-dialog-open][data-enhanced-trigger]').forEach(trigger => {
      const dialog = document.getElementById(trigger.dataset.dialogOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      trigger.hidden = false;
      scope.querySelectorAll('[data-nojs-for]').forEach(fallback => { if (fallback.dataset.nojsFor === dialog.id) fallback.hidden = true; });
    });
    scope.querySelectorAll('[data-localization-disclosure]').forEach(disclosure => {
      if (disclosure.dataset.ready) return;
      const panel = disclosure.querySelector('[data-localization-panel]');
      const summary = disclosure.querySelector('summary');
      const dialog = document.createElement('dialog');
      if (!panel || typeof dialog.showModal !== 'function') return;
      disclosure.dataset.ready = 'true';
      dialog.className = 'localization-dialog';
      dialog.id = panel.id + '-dialog';
      dialog.setAttribute('aria-labelledby', panel.querySelector('h2').id);
      panel.querySelector('[data-localization-close]').hidden = false;
      dialog.append(panel);
      disclosure.after(dialog);
      summary.setAttribute('aria-haspopup', 'dialog');
      summary.setAttribute('aria-controls', dialog.id);
      summary.setAttribute('aria-expanded', 'false');
      summary.addEventListener('click', event => { event.preventDefault(); openLocalization(summary); });
      dialog.addEventListener('close', () => summary.setAttribute('aria-expanded', 'false'));
    });
    if (document.querySelector('.localization-dialog')) document.querySelectorAll('[data-open-localization]').forEach(button => { button.hidden = false; });
  }
  document.addEventListener('click', event => {
    const localizer = event.target.closest('[data-open-localization]');
    if (localizer) { event.preventDefault(); openLocalization(localizer); return; }
    const closer = event.target.closest('[data-localization-close], [data-dialog-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog && !dialog.open) { dialogTriggers.set(dialog, opener); dialog.showModal(); }
      return;
    }
    if (event.target.tagName === 'DIALOG') {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.tagName !== 'DIALOG') return;
    const trigger = dialogTriggers.get(event.target);
    if (trigger?.isConnected) trigger.focus();
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || document.querySelector('dialog[open]')) return;
    document.querySelectorAll('.shop-mobile-menu[open], [data-localization-disclosure][open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
})();
